import { useState } from "react";

const isProd = process.env.NODE_ENV === "production";

const FileViewer: React.FC<{ src: string; height: string; width: string }> = props => {
  const [loading, setLoading] = useState(true);
  
  const secureSrc = isProd
    ? `${props.src.replace(/^http:\/\//i, "https://")}?t=${Date.now()}`
    : props.src;

  return (
    <>
      {loading && <div>Chargement du PDF...</div>}
      <iframe
        src={secureSrc}
        height={props.height}
        width={props.width}
        title={props.src}
        id="viewer-Iframe"
        name={`${Date.now()}`}
        allowFullScreen={true}
        onLoad={() => setLoading(false)}
      />
    </>
  );
};

export default FileViewer;
